import React, { useEffect, useState, useCallback } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "../msalConfig";
import { useNavigate } from "react-router-dom";
import VSISELogo from "../components/VSISELogo";

const Login = () => {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Manejar el estado de autenticación
  useEffect(() => {
    const checkAuth = async () => {
      try {
        // Procesar la respuesta de redirección si existe
        const response = await instance.handleRedirectPromise();
        if (response) {
          instance.setActiveAccount(response.account);
        } else {
          // Si no hay respuesta, verificar si hay una cuenta activa
          const accounts = instance.getAllAccounts();
          if (accounts.length > 0) {
            instance.setActiveAccount(accounts[0]);
          }
        }
      } catch (err) {
        console.error("Error al verificar autenticación:", err);
        setError("Error al verificar el estado de autenticación");
      }
    };

    checkAuth();
  }, [instance]);

  // Redirigir si está autenticado
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleLogin = useCallback(async () => {
    if (isLoading || inProgress !== "none") return;
    
    try {
      setIsLoading(true);
      setError(null);
      
      // Iniciar sesión con redirección
      await instance.loginRedirect(loginRequest);
    } catch (err) {
      console.error("Error al iniciar sesión:", err);
      setError("Ocurrió un error al intentar iniciar sesión. Por favor, inténtalo de nuevo.");
    } finally {
      setIsLoading(false);
    }
  }, [instance]);

  return (
    <div 
      style={{
        minHeight: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(180deg, #ffffff,#adecff)",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <div style={{ marginBottom: 48 }}>
          <VSISELogo style={{ width: 'min(70vw, 320px)', height: 'auto', maxHeight: 120 }} />
        </div>
        {error && (
          <div style={{
            backgroundColor: 'rgba(254, 226, 226, 0.9)',
            color: '#b91c1c',
            padding: '12px 16px',
            borderRadius: 4,
            marginBottom: 24,
            maxWidth: '80%',
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}
        <button
          onClick={handleLogin}
          disabled={isLoading}
          style={{
            padding: "12px 40px",
            borderRadius: 4,
            background: "#0078d4",
            color: "white",
            border: "none",
            fontSize: 16,
            fontWeight: 700,
            letterSpacing: 1,
            boxShadow: "0 4px 24px rgba(0,0,0,0.13)",
            cursor: "pointer",
            transition: "background 0.2s",
            margin: "0 auto",
            display: "block",
            opacity: isLoading ? 0.75 : 1,
            pointerEvents: isLoading ? 'none' : 'auto'
          }}
        >
          {isLoading ? 'Iniciando sesión...' : 'Iniciar sesión'}
        </button>
      </div>
    </div>
  );
};

export default Login;
